export enum UploadUri {
    Image = 'uploads/images',
}
